export default {
  account_type: '账户类型',
  category: '类别',
  code: '编号',
  confirm_password: '密码确认',
  discount_amount: '折扣余额',
  discount_description: '折扣说明',
  discount_method: '折扣方式',
  due_date: '截止日期',
  full_name: '全名',
  gender: '性别',
  id: '身份证号',
  identity_type: '身份证类型',
  invoice_date: '发票日期',
  name: '名字',
  nationality: '国籍',
  password: '密码',
  remark: '备注',
  role: '角色',
  username: '用户名',
  amount_receive: '收款总额',
  amount: 'Amaun',
  customer_name: 'Nama Pelanggan',
  total_no_of_people: 'Jumlah Pelanggan',
  total_no_of_days: 'Jumlah Dhari',
  start_date: 'Tarikh Mula',
  end_date: 'Tarikh Akhir',
  license_no: 'No Akaun / No Lesen',
  email_address: '电邮地址'
}
